/* eslint-env jquery */

'use strict';

class CircleProgressBarView {
  constructor({ selector = '.circular-progress-bar' }) {
    this.$status = document.querySelector(`${selector} .status`);
    this.$rightSlice = document.querySelector(`${selector} .right-half .slice`);
    this.$leftSlice = document.querySelector(`${selector} .left-half .slice`);
    this.$leftHalf = document.querySelector(`${selector} .left-half`);
  }

  updateProgress(progress, text) {
    if (!(0 <= progress && progress <= 1)) {
      return;
    }
    let firstHalfAngle = 180;
    let secondHalfAngle = 0;

    const drawAngle = progress * 360;
    if (drawAngle <= 180) {
      firstHalfAngle = drawAngle;
    } else {
      this.removeClips(this.$leftHalf);
      this.removeClips(this.$rightSlice);
      secondHalfAngle = drawAngle - 180;
    }

    this.rotate(this.$rightSlice, firstHalfAngle);
    this.rotate(this.$leftSlice, secondHalfAngle);
    if (this.$status) {
      this.$status.textContent = text;
    }
  }

  rotate(element, degree) {
    if (element) {
      element.style.transform = `rotate(${degree}deg)`;
    }
  }

  removeClips(element) {
    if (element) {
      element.style.clip = 'auto';
    }
  }
}

module.exports = CircleProgressBarView;
